// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__AuSY7","spin":"Loader_spin__23mkb","aaloader":"Loader_aaloader__2tf_s","dynamicSizeLoader":"Loader_dynamicSizeLoader__QwtER"};